
import { Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Home from './pages/Home';
import About from './pages/About';
import pageMetaData from './constants/metaData';
import Header from './components/Header';
import Footer from './components/Footer';
import Pricing from './pages/Pricing';
import ScrollToTop from './components/ScrollToTop';
import Aisoftware from './pages/services/ai-software-engineers';
import Digitalmarkiting from './pages/services/Digitalmarkiting';
import Adminsupport from './pages/services/Adminsupport';
import TeamServices from './pages/services/Teamservices';
import Aidataindustry from './pages/industries/Ai-data-industry';
import ItAndSoftware from './pages/industries/It-and-software-industry';
import Contact from './pages/contact';
import ECommerceAndRetailIndustry from './pages/industries/e-commerce-and-retail-industry';
import EducationAndCoachingIndustry from './pages/industries/education-and-coaching-industry';
import HealthcareAndWellnessIndustry from './pages/industries/healthcare-and-wellness-industry';
import MarketingAndAdvertisingIndustry from './pages/industries/marketing-and-advertising-industry';
import RealEstateIndustry from './pages/industries/real-estate-industry';
import StartupsAndEntrepreneurIndustry from './pages/industries/startups-and-entrepreneur-industry';
import Blogpage from './pages/BlogPage';
import Serviceoffer from './pages/Blogs/services-offered-in-customer-support';
import Alookup from './pages/Blogs/A-look-at-a-virtual-assistants-work-desk-setup';
import Areview from './pages/Blogs/A-review-of-trustworthy-admin-support-service';
import AIMl from './pages/services/Ai-ml';
import Dedicateddevolper from './pages/services/Dedicated-developer';
import DevopsCloud from './pages/services/devops-cloud';
import QATesting from './pages/services/qa-testing';
import ProjectManagement from './pages/services/project-management';
import EmailMarketing from './pages/services/email-marketing';
import SeoOptimization from './pages/services/seo-optimization';
import EcommerceMarketing from './pages/services/ecommerce-marketing';
import ContentWriting from './pages/services/content-writing';
import ResearchReport from './pages/services/research-report';
import AdminSupport from './pages/services/admin-support';
import CustomerSupport from './pages/services/customer-support';
import LiveChatSupport from './pages/services/live-chat-support';
import TechnicalSupport from './pages/services/technical-support';
import RemoteTeamScaling from './pages/services/remote-team-scaling';
import HireDedicatedTeam from './pages/services/hire-dedicated-team';
import TalentVettingProcess from './pages/services/talent-vetting-process';
import Onboarding from './pages/services/onboarding';
import PrivacyPolicy from './pages/privacy-policy';
import Support from './pages/support';
import RefundPolicy from './pages/Refund-policy';

import NotFound from './pages/NotFound';
function App() {
  const location = useLocation();
  const hideShell = location && location.pathname === '/hirenow';
  
  // Function to get current page meta data
  const getCurrentPageMeta = () => {
    const path = location.pathname.replace('/', '');
    
    // If empty path, return home metadata
    if (path === '') return pageMetaData.home;
    
    // Try to find a case-insensitive match in the metadata
    const metaDataKey = Object.keys(pageMetaData).find(
      key => key.toLowerCase() === path.toLowerCase()
    );
    
    // If a match is found, return its metadata
    if (metaDataKey) {
      return pageMetaData[metaDataKey];
    }
    
    // If no matching metadata is found, return the notFound metadata
    return pageMetaData.notFound;
  };

  const currentMeta = getCurrentPageMeta();

  return (
    <HelmetProvider>
      <div className="App">
        <Helmet>
          <title>{currentMeta.title}</title>
          <meta name="description" content={currentMeta.description} />
        </Helmet>
        <ScrollToTop />
        {!hideShell && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/Pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
    
        <Route path="/Aisoftware" element={<Aisoftware />} />
        <Route path="/Digitalmarkiting" element={<Digitalmarkiting />} />
        <Route path="/Adminsupport" element={<Adminsupport />} />
        <Route path="/TeamServices" element={<TeamServices />} />
        <Route path="/Ai-data-industry" element={<Aidataindustry />} />
  <Route path="/It-and-software-industry" element={<ItAndSoftware />} />
  <Route path="/E-commerce-and-retail-industry" element={<ECommerceAndRetailIndustry />} />
  <Route path="/Education-and-coaching-industry" element={<EducationAndCoachingIndustry />} />
  <Route path="/Healthcare-and-wellness-industry" element={<HealthcareAndWellnessIndustry />} />
  <Route path="/Marketing-and-advertising-industry" element={<MarketingAndAdvertisingIndustry />} />
  <Route path="/Real-estate-industry" element={<RealEstateIndustry />} />
  <Route path="/Startups-and-entrepreneur-industry" element={<StartupsAndEntrepreneurIndustry />} />
        <Route path="/blog" element={<Blogpage />} />
        <Route path="/services-offered-in-customer-support" element={<Serviceoffer />} />
        <Route path="/a-look-at-a-virtual-assistants-work-desk-setup" element={<Alookup />} />
        <Route path="/a-review-of-trustworthy-admin-support-service" element={<Areview />} />
        <Route path="/Ai-ml" element={<AIMl />} />
        <Route path="/Dedicated-developer" element={<Dedicateddevolper />} />
        <Route path="/devops-cloud" element={<DevopsCloud />} />
        <Route path="/qa-testing" element={<QATesting />} />
        <Route path="/project-management" element={<ProjectManagement />} />
        <Route path="/email-marketing" element={<EmailMarketing />} />
        <Route path="/seo-optimization" element={<SeoOptimization />} />
        <Route path="/ecommerce-marketing" element={<EcommerceMarketing />} />
        <Route path="/content-writing" element={<ContentWriting />} />
        <Route path="/research-report" element={<ResearchReport />} />
        <Route path="/admin-support" element={<AdminSupport />} />
        <Route path="/customer-support" element={<CustomerSupport />} />
        <Route path="/live-chat-support" element={<LiveChatSupport />} />
        <Route path="/technical-support" element={<TechnicalSupport />} />
        <Route path="/remote-team-scaling" element={<RemoteTeamScaling />} />
        <Route path="/hire-dedicated-team" element={<HireDedicatedTeam />} />
        <Route path="/talent-vetting-process" element={<TalentVettingProcess />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/support" element={<Support />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        {/* Catch-all 404 route - must be last */}
        <Route path="*" element={<NotFound />} />





      </Routes>
      {!hideShell && <Footer />}
    </div>
    </HelmetProvider>
  );
}

export default App;